import { Alert, AlertColor, AlertTitle, Container, Stack } from "@mui/material";
import { Loader } from "./loader";
import { JSX } from "react";

export interface EmptyTableAlertProps {
  title?: string;
  subTitle: string;
  severity: AlertColor;
  showIcon?: boolean;
  mainIcon?: JSX.Element;
  loading?: boolean;
}

const EmptyTableAlert = ({
  subTitle,
  severity,
  mainIcon,
  showIcon,
  loading = false,
}: EmptyTableAlertProps) => {
  return (
    <Container
      sx={{
        maxHeight: 850,
        display: "flex",
        justifyItems: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      {loading && <Loader height={750} />}
      {!loading && !showIcon && (
        <Alert icon={false} severity={severity} sx={{ mt: 10 }} color="info">
          <AlertTitle>{subTitle}</AlertTitle>
        </Alert>
      )}
      {!loading && showIcon && (
        <Container
          sx={{
            minHeight: 250,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Stack
            direction={"column"}
            justifyContent="center"
            alignItems="center"
          >
            {mainIcon}
            {subTitle}
          </Stack>
        </Container>
      )}
    </Container>
  );
};

export default EmptyTableAlert;
